<template>
  <div
    v-show="isUserRendered"
    ref="user-item-ref"
    class="prize_user_row"
  >
    <div
      :class="['user_img_bg', {not_clickable: user.__profileViewRestricted}]"
      @click="emitViewProfile"
    >
      <AvatarImage :src="user.avatar" />
    </div>

    <div class="col_mobile">
      <div class="user_info">
        <p
          :class="['name', {not_clickable: user.__profileViewRestricted}]"
          @click="emitViewProfile"
        >
          {{ user.username }}
        </p>
      </div>

      <div class="date_box">
        <p class="date_txt">{{ $_translations.value.page_leaderboard_section_users_points }} </p>

        <p class="date">{{ user.points }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import AvatarImage from '@/components/image/AvatarImage.vue';
import useRenderAnimatedItemHook from '@/hooks/useRenderAnimatedItem.js';

const emits = defineEmits(['view:profile']);

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
  animated: {
    type: Boolean,
    default: true,
  },
});

const [isUserRendered, renderUser] = useRenderAnimatedItemHook('user-item-ref');

const emitViewProfile = () => {
  if (props.user.__profileViewRestricted) { return; }

  emits('view:profile', props.user);
};

onMounted(() => {
  renderUser(props.animated);
});
</script>
